module.exports = __webpack_public_path__ + "img/sidebar-store-2.3d8e3a6c.jpg";